import { FEATURE_FLAG } from '~/constants';

import { RouteExportParams } from '~/types/router.type';

export const routeParams: RouteExportParams = {
  featureFlag: [
    FEATURE_FLAG.MODULE_CONTRACTS, // company-account feature flag managed in the admin app
    FEATURE_FLAG.MANAGE_CONTRACTS, // user feature flag managed in the user form
  ],
};
